import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

interface DeleteOption {
  label: string;
  isAllocated: boolean | null; // null: all, true: allocated only, false: unallocated only
  count: number;
}

@Component({
  selector: 'app-delete-nfc-url-popup',
  standalone: false,
  templateUrl: './delete-nfc-url-popup.html',
  styleUrl: './delete-nfc-url-popup.scss'
})
export class DeleteNfcUrlPopup {
  options: DeleteOption[];
  selectedOption: DeleteOption;

  constructor(
    private readonly dialogRef: MatDialogRef<DeleteNfcUrlPopup>,
    @Inject(MAT_DIALOG_DATA) public data: { allocatedCount: number; unallocatedCount: number }
  ) {
    this.options = [
      { label: 'Delete all', isAllocated: null, count: data.allocatedCount + data.unallocatedCount },
      { label: 'Delete only allocated URLs', isAllocated: true, count: data.allocatedCount },
      { label: 'Delete only unallocated URLs', isAllocated: false, count: data.unallocatedCount }
    ];
    // Default to the least destructive option that has rows
    this.selectedOption = data.unallocatedCount > 0 ? this.options[2] : this.options[1];
  }

  /** True when the chosen option can remove allocated URLs from users' binders. */
  get includesAllocated(): boolean {
    return this.selectedOption.isAllocated !== false && this.data.allocatedCount > 0;
  }

  close() {
    this.dialogRef.close();
  }

  confirmDelete() {
    this.dialogRef.close({ isAllocated: this.selectedOption.isAllocated });
  }
}
